import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  logOutUser,
  selectMuid,
} from '@meprism/shared/src/redux/authentication/authenticationSlice'
import { Container } from '@mui/material'
// eslint-disable-next-line import/no-unresolved, import/no-extraneous-dependencies
import Lottie from 'lottie-react'
import loaderJson from '@meprism/shared/src/assets/icons/loader.json'
import { useAppDispatch, useAppSelector } from '../../redux/storeExports'

const Logout = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const isUserAuthenticated = useAppSelector(selectMuid)

  useEffect(() => {
    dispatch(logOutUser())
  }, [dispatch])

  useEffect(() => {
    if (!isUserAuthenticated) {
      navigate('/login')
    }
  }, [isUserAuthenticated, navigate])

  return (
    <Container fixed maxWidth={'sm'}>
      <div style={{ width: 100, height: 100 }}><Lottie animationData={loaderJson} loop={true} /></div>
    </Container>
  )
}

export default Logout
